const loader = () => {
    const loader = document.createElement('div');
    loader.classList.add('rit-loader')

    return loader;
}

export default loader;